<template>
  <v-app-bar
    class="w-100 elevation-0"
    style="background-color: #f5f8fa; border: none; height: 48px;"
  >
    <div class="top-bar-container d-flex justify-space-between align-center w-100 h-100 pl-3">
      
      <div class="pageTitle d-flex justify-start align-center ga-2" @click="$router.push('/')" style="cursor: pointer;">
        <component :is="pageStore.currentPage.icon" v-if="pageStore.currentPage.icon" />
          <div class="d-flex align-center justify-center ga-2" v-if="showPlanBadge && finances.plan === 'free'">
          <v-chip
            class="plan-badge ml-2"
            variant="outlined"
            label
          >
            Teste gratuito
          </v-chip>
          <div class="verticalDivider mx-2"></div>
        </div>

        <v-app-bar-title class="pageTitle">{{ pageStore.currentPage.title }}</v-app-bar-title>
      </div>

      <div class="d-flex align-center h-100">
        <router-link class="monitoring-link" to="/resources-dashboard" v-if="canAccessMonitoring">
          <span class="mr-4">Monitoramento de uso</span>
        </router-link>

        <v-btn
          @click="openHelpBar"
          :loading="helpbar.loading.value"
          class="d-flex align-center h-100"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M8.95829 14C9.24996 14 9.49649 13.8993 9.69788 13.6979C9.89927 13.4965 9.99996 13.25 9.99996 12.9583C9.99996 12.6666 9.89927 12.4201 9.69788 12.2187C9.49649 12.0173 9.24996 11.9166 8.95829 11.9166C8.66663 11.9166 8.4201 12.0173 8.21871 12.2187C8.01732 12.4201 7.91663 12.6666 7.91663 12.9583C7.91663 13.25 8.01732 13.4965 8.21871 13.6979C8.4201 13.8993 8.66663 14 8.95829 14ZM8.20829 10.7916H9.74996C9.74996 10.3333 9.80204 9.97218 9.90621 9.70829C10.0104 9.4444 10.3055 9.08329 10.7916 8.62496C11.1527 8.26385 11.4375 7.9201 11.6458 7.59371C11.8541 7.26732 11.9583 6.87496 11.9583 6.41663C11.9583 5.63885 11.6736 5.04163 11.1041 4.62496C10.5347 4.20829 9.86107 3.99996 9.08329 3.99996C8.29163 3.99996 7.64927 4.20829 7.15621 4.62496C6.66315 5.04163 6.3194 5.54163 6.12496 6.12496L7.49996 6.66663C7.5694 6.41663 7.72565 6.14579 7.96871 5.85413C8.21177 5.56246 8.58329 5.41663 9.08329 5.41663C9.52774 5.41663 9.86107 5.53815 10.0833 5.78121C10.3055 6.02427 10.4166 6.29163 10.4166 6.58329C10.4166 6.86107 10.3333 7.12149 10.1666 7.36454C9.99996 7.6076 9.79163 7.83329 9.54163 8.04163C8.93052 8.58329 8.55552 8.99302 8.41663 9.27079C8.27774 9.54857 8.20829 10.0555 8.20829 10.7916ZM8.99996 17.3333C7.84718 17.3333 6.76385 17.1145 5.74996 16.677C4.73607 16.2395 3.85413 15.6458 3.10413 14.8958C2.35413 14.1458 1.76038 13.2638 1.32288 12.25C0.885376 11.2361 0.666626 10.1527 0.666626 8.99996C0.666626 7.84718 0.885376 6.76385 1.32288 5.74996C1.76038 4.73607 2.35413 3.85413 3.10413 3.10413C3.85413 2.35413 4.73607 1.76038 5.74996 1.32288C6.76385 0.885376 7.84718 0.666626 8.99996 0.666626C10.1527 0.666626 11.2361 0.885376 12.25 1.32288C13.2638 1.76038 14.1458 2.35413 14.8958 3.10413C15.6458 3.85413 16.2395 4.73607 16.677 5.74996C17.1145 6.76385 17.3333 7.84718 17.3333 8.99996C17.3333 10.1527 17.1145 11.2361 16.677 12.25C16.2395 13.2638 15.6458 14.1458 14.8958 14.8958C14.1458 15.6458 13.2638 16.2395 12.25 16.677C11.2361 17.1145 10.1527 17.3333 8.99996 17.3333Z"
              fill="#8E9191" />
          </svg>
        </v-btn>

        <div class="verticalDivider"></div>
        <UserAvatar />
      </div>
    </div>
  </v-app-bar>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useFinanceStore } from '@/assistents/stores/finance';
import { usePageStore } from '@/ai_studio/stores/pageStore'
import { helpbar } from '@/ai_studio/utils/helpbar'
import UserAvatar from "@/ai_studio/components/layout/UserAvatar.vue"
import { useUserStore } from '@/ai_studio/stores/user'
import { PERMISSIONS } from '@/ai_studio/constants/permissions'

const route = useRoute()
const pageStore = usePageStore()
const finances = useFinanceStore()
const userStore = useUserStore()

const showPlanBadge = computed(() => {
  return route.meta?.showPlanBadge === true
})

const canAccessMonitoring = computed(() => {
  return userStore.hasPermission(PERMISSIONS.MONITORAMENTO_USO)
})

const fetchPlanStatus = async () => {
  try {
    const response = await axios.get('/api/assistents/resources/plan-status')
    finances.plan = response.data.plan

  } catch (err) {
    console.error(err)
  }
}

watch(showPlanBadge, async (shouldShow) => {
  if (shouldShow) {
    await fetchPlanStatus()
  }
}, { immediate: true })

const openHelpBar = () => {
  helpbar.open(pageStore.currentPage.helpKey)
}

</script>

<style scoped>
.monitoring-link {
  font-family: Roboto;
  text-decoration: none;
  color: rgb(var(--v-theme-neutral-35));
  white-space: nowrap;
}

.pageTitle {
  color: rgb(var(--v-theme-neutral-35));
  text-decoration: none;
  font-size: 16px;
}

.verticalDivider {
  width: 2px;
  height: 27px;
  background-color: #D4D4D4;
}

.top-bar-container {
  background-color: #f5f8fa;
}

.plan-badge {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 500;
  height: 32px !important;
  padding: 6px 16px;
  color:#354860;
  border-radius: 8px;
  line-height: 20px;
  letter-spacing: 0.1px;
  border-color: #C5C7C6;
}
</style>
